import React from 'react';
import PropTypes from 'prop-types';
import MobileMenuForward from 'components/nav/shared/MobileMenuForward';
import MobileMenuBack from 'components/nav/shared/MobileMenuBack';
import PenNamesMenu from 'components/nav/authenticated/mobile/PenNamesMenu';
import MainMenu from 'components/nav/authenticated/mobile/MainMenu';
import NavLink from 'components/nav/shared/NavLink';

import IdentityStore from 'stores/IdentityStore';

class AccountManageMenu extends React.Component {
  static propTypes = {
    transitionToMenu: PropTypes.func.isRequired,
  };

  static menuName = 'accountManage';

  constructor(props) {
    super(props);
    this.handlePenNamesClick = this.handlePenNamesClick.bind(this);
    this.handleMainClick = this.handleMainClick.bind(this);
  }

  handlePenNamesClick() {
    this.props.transitionToMenu(PenNamesMenu.menuName);
  }

  handleMainClick() {
    this.props.transitionToMenu(MainMenu.menuName);
  }

  render() {
    const showPenNameSwitcher = IdentityStore.getState().identities.length > 1;

    return (
      <ul className="nav navbar-nav">
        <li><MobileMenuBack callback={this.handleMainClick} stringID="AA_Main_Menu" /></li>
        { showPenNameSwitcher
          ? <li><MobileMenuForward callback={this.handlePenNamesClick} stringID="AA_Switch_Pen_Name" /></li> : null }
        <li><NavLink to="/account/preferences" stringID="AA_Preferences" shouldRefresh={false} /></li>
      </ul>
    );
  }
}

export default AccountManageMenu;
